import * as controllers from '../controllers';

export default function exposeControllers() {
    Object.keys(controllers).forEach((key) => {
        window[key] = controllers[key];
    });
}
